import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { IBuildingForFutureDetailsData } from "../../exports/interfaces";
import { useMobile } from "../../hooks/custom/useMobile";

export const UniversityDescription = ({
  buildingForFutureDetails,
}: {
  buildingForFutureDetails: IBuildingForFutureDetailsData[];
}) => {
  const location = useLocation();
  const isMobile = useMobile();
  useEffect(() => {
    if (!location.hash || buildingForFutureDetails.length === 0) return;

    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash, buildingForFutureDetails]);

  return (
    <section>
      <div className="td_height_120 td_height_lg_40" />
      <div className="container">
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          <p
            className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color"
            style={{ textAlign: "unset" }}
          >
            COMMUNITY
          </p>
          <h2 className="td_section_title td_fs_48 mb-0">
            Building a University for Nepal's Future
          </h2>
        </div>
        <div className="td_height_50 td_height_lg_50" />

        <div className="row td_gap_y_24">
          {buildingForFutureDetails.map((data, index) => {
            const isEven = index % 2 === 0;
            return (
              <section
                id={`${index === 1 ? "campus-idea" : index === 2 ? "how-you-can-help" : ""}`}
                key={index}
              >
                <div className="col-xl-12">
                  <div
                    className="td_post td_style_1 td_type_1"
                    style={
                      !isMobile
                        ? { flexDirection: isEven ? "row" : "row-reverse" }
                        : {}
                    }
                  >
                    <div className="td_post_thumb d-block">
                      <img
                        src={`${process.env.REACT_APP_cmsUrl}/uploads/${data?.image[0]?.media?.name}`}
                        alt={data?.title}
                      />
                    </div>
                    <div
                      className="td_post_info custom-text-p"
                    >
                      <h2 className=" td_fs_24 td_medium td_mb_16">
                        {data?.title}
                      </h2>
                      <span
                        className="td_opacity_7 td_fs_18"
                        dangerouslySetInnerHTML={{
                          __html: data?.description,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </section>
            );
          })}
        </div>
      </div>

      <div className="td_height_120 td_height_lg_40" />
    </section>
  );
};
